<!-- 推荐使用grid-table-th替代 -->
<template>
  <li class="main-table-cell main-table-cell-medium">
    <div class="main-table-cell-wrap">
      <span class="main-table-txt"><slot></slot></span>
    </div>
  </li>
</template>
<script>
  export default {
    name: 'grid-table-col'
  }
</script>



// WEBPACK FOOTER //
// src/components/grid-menu/grid-table-col.vue